import Image from 'next/image';

import { ActionIcon } from '@mantine/core';
import { IconX } from '@tabler/icons-react';

export const Modal = ({
  title,
  icon = undefined,
  iconSize = 24,
  iconBackground = true,
  iconRounded = false,
  confirmation = false,
  fullScreen = true,
  children,
  extra,
  showModal,
  showCloseButton,
  handleCloseModal,
}: {
  title: string | React.ReactNode;
  icon?: string | React.ReactNode | undefined;
  iconSize?: number;
  iconBackground?: boolean;
  iconRounded?: boolean;
  confirmation?: boolean;
  children: React.ReactNode;
  extra?: React.ReactNode;
  showModal: boolean;
  showCloseButton?: boolean;
  handleCloseModal: () => void;
  fullScreen?: boolean;
}) => {
  const classes = fullScreen
    ? 'bg-white transform transition-all w-full h-full overflow-auto'
    : 'bg-white rounded-[2rem] transform transition-all w-2/5 overflow-auto sm:max-w-2xl xl:max-w-4xl';
  return showModal ? (
    <div className="fixed inset-0 flex items-center justify-center z-40">
      <div className="absolute inset-0 bg-gradient-to-r from-overlay-100/75 to-primary-200/75 backdrop-blur"></div>
      <div className={classes}>
        {confirmation && showCloseButton && (
          <div className="absolute top-5 right-5">
            <ActionIcon
              variant="outline"
              color="gray"
              aria-label="close-modal"
              onClick={handleCloseModal}
            >
              <IconX style={{ width: '24', height: '24' }} stroke={1.5} />
            </ActionIcon>
          </div>
        )}
        <div
          className={`flex items-center p-8 ${confirmation ? 'justify-center' : 'border-b border-gray-200 justify-between'}`}
        >
          <div
            className={`flex items-center gap-3 ${confirmation && 'flex-col'}`}
          >
            {icon && (
              <div
                className={`${iconBackground && 'bg-secondary-25 p-3 rounded-2xl'}`}
              >
                {typeof icon === 'string' ? (
                  <Image
                    className={`${iconRounded && 'rounded-full'}`}
                    src={icon}
                    alt="icon"
                    width={iconSize}
                    height={iconSize}
                  />
                ) : (
                  <>{icon}</>
                )}
              </div>
            )}
            {title && (
              <span
                className={`${confirmation ? 'text-3xl max-w-[416px] text-center' : 'text-2xl'} font-bold`}
              >
                {title}
              </span>
            )}
          </div>
          <div className="flex gap-3">
            {!confirmation && (
              <ActionIcon
                variant="subtle"
                color="gray"
                aria-label="close-modal"
                onClick={handleCloseModal}
              >
                <IconX style={{ width: '24', height: '24' }} stroke={1.5} />
              </ActionIcon>
            )}
          </div>
        </div>
        {!!extra && extra}
        <div className={`px-8 ${confirmation ? 'pb-12' : 'py-12'}`}>
          {children}
        </div>
      </div>
    </div>
  ) : null;
};
